import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import { observer } from "mobx-react";
import Cart from "services/store/Cart";
import { useNavigate } from "react-router-dom";
import "./RightPanel.scss"
import CartItem from "components/CartItem/CartItem";
import Button from '@mui/material/Button';
import { toast } from 'react-toastify';

const RightPanel = ({token, opened}) => {
  const navigate = useNavigate();
  const [canOrder, setCanOrder] = useState(false);
  const [comment, setComment] = useState("");
  const [inactivityTimer, setInactivityTimer] = useState(null);
  const [toastShown, setToastShown] = useState(false);
  
  const redirectToPayment = () => {
    if (!canOrder) return;

    navigate("/payment");
  }

  const setCartComment = (value) => {
    setComment(value);
    Cart.comment = value;
  }

  // Fonction pour réinitialiser le timer d'inactivité
  const resetInactivityTimer = () => {
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
    }
    
    // Ne créer le timer que si le toast n'a pas encore été affiché
    if (!toastShown) {
      const timer = setTimeout(() => {
        toast.info("Cliquez à nouveau sur le « logo panier » pour continuer vos achats", {
          position: "bottom-right",
          autoClose: 6000,
        });
        setToastShown(true); // Marquer que le toast a été affiché
      }, 10000); // 10 secondes
      
      setInactivityTimer(timer);
    }
  };

  // Gestionnaire d'événements pour détecter l'activité
  const handleUserActivity = () => {
    resetInactivityTimer();
  };

  useEffect(() => {
    if (Cart.cartMessage && opened) {
      toast.info(Cart.cartMessage, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  }, [Cart.cartMessage, opened]);

  useEffect(() => {
    if (Cart.cart?.length > 0) {
      setCanOrder(true);
    } else {
      setCanOrder(false);
    }
  }, [Cart.cart?.length, token]);

  // Effet pour gérer la détection d'inactivité
  useEffect(() => {
    let currentTimer = null;
    
    if (opened) {
      // Réinitialiser l'état du toast quand le panneau s'ouvre
      setToastShown(false);
      
      // Fonction pour créer le timer
      const createTimer = () => {
        if (!toastShown) {
          currentTimer = setTimeout(() => {
            toast.info("Cliquez à nouveau sur le « logo panier » pour continuer vos achats", {
              position: "bottom-right",
              autoClose: 6000,
            });
            setToastShown(true);
          }, 10000);
          setInactivityTimer(currentTimer);
        }
      };
      
      // Fonction pour réinitialiser le timer
      const resetTimer = () => {
        if (currentTimer) {
          clearTimeout(currentTimer);
        }
        if (inactivityTimer) {
          clearTimeout(inactivityTimer);
        }
        createTimer();
      };
      
      // Démarrer le timer initial
      createTimer();
      
      // Ajouter les écouteurs d'événements pour détecter l'activité
      document.addEventListener('mousedown', resetTimer);
      document.addEventListener('keydown', resetTimer);
      document.addEventListener('touchstart', resetTimer);
      document.addEventListener('scroll', resetTimer);
      
      // Nettoyer les écouteurs d'événements et le timer
      return () => {
        if (currentTimer) {
          clearTimeout(currentTimer);
        }
        if (inactivityTimer) {
          clearTimeout(inactivityTimer);
        }
        document.removeEventListener('mousedown', resetTimer);
        document.removeEventListener('keydown', resetTimer);
        document.removeEventListener('touchstart', resetTimer);
        document.removeEventListener('scroll', resetTimer);
      };
    } else {
      // Si le panneau est fermé, nettoyer le timer
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
        setInactivityTimer(null);
      }
    }
  }, [opened, toastShown]); // Dépendances simplifiées

  return (
    <div className={`right-panel ${opened ? "opened" : ""}`} id="menu-right">
      <p>Panier</p>
      <div className="cart-container">
        {Cart.cart.map((product, index) => (
          <CartItem product={product} token={token} key={index} />
        ))}
      </div>
      <p>Total commandé : {Cart.orderPrice} €</p>
      <p>Colis estimés : {Cart.parcelCount}</p>

      <Button 
        disabled={!Cart.canValidate || !canOrder} 
        style={{fontSize: '16px'}} 
        className="w-100 mt-3 mb-5" 
        variant="contained" 
        type="button" 
        onClick={redirectToPayment}>
          Commander
      </Button>

      {Cart.paymentCard && (
        <div>
          <TextField 
              id="comment" 
              label="Commentaire" 
              value={comment}
              variant="outlined"
              size="small"
              multiline
              rows={3}
              onChange={e => setCartComment(e.target.value)} />
        </div>
      )}
    </div>
  )
}

export default observer(RightPanel);